/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_DescriptionInputs */

const en_admin_posts_description = /** @type {(inputs: Admin_Posts_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage blog posts and articles`)
};

/**
* | output |
* | --- |
* | "Manage blog posts and articles" |
*
* @param {Admin_Posts_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_description = /** @type {((inputs?: Admin_Posts_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_description(inputs)
});
export { admin_posts_description as "admin.posts.description" }